<img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>

<mat-card class="simple-card mx-auto mb-5">
  <mat-card-content>
    <div class="row">

      <div class="col-12 d-flex justify-content-between">
        <h1>Reporte Básico</h1>
        <button
          class="no-print d-none"
          id="btn-print"
          [printTitle]='"ReporteBasico_"+(rut | rutFormat)+"_"+today'
          [useExistingCss]="true"
          printSectionId="print-section"
          ngxPrint
        ></button>

        <button mat-flat-button 
          class="custom-button-primary no-print"
          (click)="descargarPDF()"
        >
          <mat-icon 
            aria-hidden="false" 
            aria-label="Icono de descarga" 
            fontIcon="get_app" 
            class="icon-download"
          ></mat-icon>
          Descargar Resultado
        </button>
      </div>

      <div class="col-12 my-3">
        <mat-chip-set aria-label="Rut principal">
          <mat-chip class="chip-rut"><strong>RUT:</strong> {{rut | uppercase | rutFormat}}</mat-chip>
        </mat-chip-set>
      </div>

      <div class="col-12">
        <div class="row row-mat-card" *ngIf="objReporte && objReporte.length > 0">
          <ng-container *ngFor="let item of objReporte; let i = index">
            <div class="my-3 p-3" [ngClass]="(i > 0) ? ('page-break-before ' + item.class) : (item.class)">
              <mat-card class="mat-card-print">
                <mat-card-header>
                  <mat-card-title class="font-size-title-card">
                    <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                    <strong>{{item.title || ''}}</strong>
                  </mat-card-title>
                </mat-card-header>
              
                <mat-card-content>
                  <div class="row my-3 px-5 py-3" *ngIf="item?.content && item?.content.length > 0">
                    <ng-container *ngFor="let element of item?.content">
                      
                      <ng-template #isCard>
                        <div class="my-3" [ngClass]="element?.class">
                          <mat-card class="border-rounded shadow-none">
                            <mat-card-header>
                              <mat-card-title class="font-size-title-card">
                                <p>{{element.title || ''}}</p>
                              </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                              <div class="row" *ngIf="element?.content && element?.content.length > 0">
                                <ng-container *ngFor="let subContent of element?.content">
                                  <ng-container *ngTemplateOutlet="contentSwitch; context: { $implicit: subContent }"></ng-container>
                                </ng-container>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        </div>
                      </ng-template>
                      
                      <ng-container *ngIf="element?.type != 'card'; else isCard">
                        <ng-container *ngTemplateOutlet="contentSwitch; context: { $implicit: element }"></ng-container>
                      </ng-container>
                      
                    </ng-container>                    
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-container>
          
        </div>
      </div>

      <div class="col-12 my-4">
        <div class="info-span p-3">
          <p class="text-center text-wrap">
            La información presentada en estos análisis proviene de fuentes consideradas altamente confiables. Sin embargo, dada la posibilidad de error humano o mecánico, no
            se garantiza la exactitud o integridad de la información y, pot tanto, no se hace responsable de errores u omisiones, como tampoco de las consecuencias asociadas con
            el empleo de esa información.
          </p>
        </div>
      </div>

    </div>
  </mat-card-content>
</mat-card>

<ng-template #objValue let-elemento>
  <ng-container [ngSwitch]="elemento?.obj?.type">
    <ng-container *ngSwitchCase="'rut'">
      {{elemento?.obj?.value ? (elemento?.obj?.value | rutFormat) : ''}}
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      {{elemento?.obj?.value ? (elemento?.obj?.value | date: 'dd-MM-yyyy') : ''}}
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
      {{elemento?.obj?.value || ''}}
    </ng-container>
    <ng-container *ngSwitchCase="'int'">
      {{elemento?.obj?.value || elemento?.obj?.value == 0 ? (elemento?.obj?.value | number: '1.0-0') : elemento?.obj?.value}}
    </ng-container>
    <ng-container *ngSwitchCase="'decimal'">
      {{elemento?.obj?.value || elemento?.obj?.value == 0 ? (elemento?.obj?.value | number: '1.0-2') : elemento?.obj?.value}}
    </ng-container>
    <ng-container *ngSwitchCase="'int-clp'">
      {{elemento?.obj?.value || elemento?.obj?.value == 0 ? (elemento?.obj?.value | currency:'CLP':'':'1.0-0') : elemento?.obj?.value}}
    </ng-container>
    <ng-container *ngSwitchDefault>
      {{elemento?.obj?.value}}
    </ng-container>
  </ng-container>
</ng-template>


<ng-template #contentSwitch let-element>
  <ng-container [ngSwitch]="element?.type">

    <ng-container *ngSwitchCase="'table-basic'">
      <div class="col-12 my-3 mx-auto">
        <div class="table-responsive border">
          <table mat-table [dataSource]="element?.dataSource" class="info-basica-table">
            <ng-container matColumnDef="name">
              <td mat-cell *matCellDef="let element" class="cell-font-size">{{element.name}}</td>
            </ng-container>
          
            <ng-container matColumnDef="value">
              <td mat-cell *matCellDef="let element" class="cell-font-size">
                <ng-container *ngTemplateOutlet="objValue; context: { $implicit: {obj: element} }"></ng-container>
              </td>
            </ng-container>
          
            <tr
              mat-row
              *matRowDef="let row; columns: element?.displayedColumns;"
            ></tr>
          </table>
        </div>
      </div>
    </ng-container>
    
    <ng-container *ngSwitchCase="'graphRiesgoCalculado'">
      <div class="col-12 my-5 mx-auto" *ngIf="element?.name">
        <span>{{element?.name}}</span>
      </div>
      <div class="col-12 mt-3 mx-auto" *ngIf="element?.value">
        <div class="table-responsive-custom border-0">
          <div class="form-group">
            <div class="d-flex btn-group" role="group" aria-label="Basic radio toggle button group">

              <label class="btn btn-outline-primary mt-5 mx-2 alto" for="alto">Alto
                <div class="selected" *ngIf="element?.value === 'Alto'"></div>
              </label>

              <label class="btn btn-outline-primary mt-5 mx-2 medioAlto" for="medioAlto">Medio Alto
                <div class="selected" *ngIf="element?.value === 'Medio Alto'"></div>
              </label>

              <label class="btn btn-outline-primary mt-5 mx-2 medio" for="medio">Medio
                <div class="selected" *ngIf="element?.value === 'Medio'"></div>
              </label>

              <label class="btn btn-outline-primary mt-5 mx-2 medioBajo" for="medioBajo">Medio Bajo
                <div class="selected" *ngIf="element?.value === 'Medio Bajo'"></div>
              </label>

              <label class="btn btn-outline-primary mt-5 mx-2 bajo" for="Bajo">Bajo
                <div class="selected" *ngIf="element?.value === 'Bajo'"></div>
              </label>

            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'graphRiesgoBarra'">
      <div class="col-12 my-5 mx-auto" *ngIf="element?.name">
        <span>{{element?.name}}</span>
      </div>
      <div class="col-12 mt-3 mx-auto" *ngIf="element?.value">
        <div class="row">
          <div class="col-12" style="padding-top: 0.75rem;padding-bottom: 0.75rem;padding-right: 10%;padding-left: 6%;">
            <div style="width:100%;">
              <div style="width:22px;text-align: center;"
                [ngStyle]="{'margin-left': setClasificacionPosition(element?.value) + '%'}">
                <div style="width:26px;height:12px;text-align: center;font-size: 1.5rem;
                  font-weight: bold;">{{element?.value}}</div>
                <div style="width:26px;height:14px;text-align: center;"><i class="arrow down"></i></div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <img src="assets/img/barra.jpg" width="100%" alt="" />
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'graphEvolucionPredictor'">
      <div class="col-12">
        <div [chart]="element?.value" class="w-100 graphContent"></div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'tree-societarios'">
      <div class="col-12">
        <mat-tree [dataSource]="dataSourceTreeSocios" [treeControl]="treeControl">
          <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <div class="border-rounded d-flex justify-content-center align-items-center p-4 mt-2 cell-font-size">
              <!-- use a disabled button to provide padding for tree leaf -->
              <!--<button mat-icon-button disabled></button>-->
                <i class="fa fa-file-o font-weight-normal mr-3 icon-download" aria-hidden="true"></i>
                {{ node.name }} / {{ node.rut | rutFormat }}
            </div>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <div class="border-rounded pr-4 d-flex justify-content-center align-items-center cell-font-size">
              <button mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror font-weight-normal icon-download">
                  folder_open
                </mat-icon>
              </button>
              {{ node.name }} / {{ node.rut | rutFormat }}
            </div>
          </mat-tree-node>
        </mat-tree>
      </div>

    </ng-container>

    <ng-container *ngSwitchCase="'table-header'">
      <div class="col-12 my-3 mx-auto">
        <div class="table-responsive border">
          <table mat-table [dataSource]="element?.dataSource" class="info-basica-table">
            <ng-container *ngFor="let column of element?.displayedColumns">
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef> {{element?.headers[column]}} </th>
                <td mat-cell *matCellDef="let element" [ngClass]="element[column].class">
                  <ng-container *ngTemplateOutlet="objValue; context: { $implicit: {obj: element[column]} }"></ng-container>
                </td>
              </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="element?.displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: element?.displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'graphVentas'">
      <div class="col-12">
        <div class="grafico">
          <div class="table-responsive mx-auto" id="chart_div">
            <google-chart class="mx-auto" [title]="chart.title" [type]="chart.type" [data]="chart.data" [columns]="chart.columns"
              [options]="chart.options" [width]="chart.width" [height]="chart.height">
            </google-chart>

            <figure class="mt-3">
              <figcaption class="blockquote-footer">
                <cite class="cite-margin" title="Source Title">Ventas expresadas en millones de UF</cite>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'text-left'">
      <div class="col-12">
        <p>{{element?.value || ''}}</p>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'text-right'">
      <div class="col-12 text-right">
        <p>{{element?.value || ''}}</p>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="col-12">
        {{element?.value || ''}}
      </div>
    </ng-container>
  </ng-container>

</ng-template>
